export const iconFontAwesomeEditingPen = (
	<i className="fa-solid fa-pen"></i>
);
